<template>
  <transition name="fade">
    <div class="login-wrapper" v-show="visible">
      <div class="login-container">
        <div class="close-btn" @click="closeLoginPop"></div>
        <div class="logo-wrap">
          <img :src="logo" alt="">
        </div>
        <div class="form-container">
          <div class="form-item">
            <div class="form-item__content">
              <div class="form-item__input">
                <input type="text" v-model="login.email" :placeholder="$t('userOperate.emailHolder')" autocomplete="off" @blur.prevent="validateEmail" @focus="inputFocus(error.email)">
              </div>
              <div class="form-item__error" v-show="error.email.isShow">* {{error.email.msg}}</div>
            </div>
          </div>
          <div class="form-item">
            <div class="form-item__content">
              <div class="form-item__input only--password">
                <input :type="seen ? 'text' : 'password'" v-model="login.password" :placeholder="$t('userOperate.pswHolder')" autocomplete="off" @blur.prevent="validatePass" @focus="inputFocus(error.password)">
                <em class="cansee-icon" :class="{'cansee': seen}" @click="toggleCanSee"></em>
              </div>
              <div class="form-item__error" v-show="error.password.isShow">* {{error.password.msg}}</div>
            </div>
          </div>
          <div class="form-item">
            <div class="form-item__content">
              <div class="form-item__input only--checkcode">
                <input type="text" v-model="login.checkcode" :placeholder="$t('userOperate.codeHolder')" autocomplete="off" @blur.prevent="validateCheckcode" @focus="inputFocus(error.checkcode)" @keyup.enter="loginMethod">
                <div class="checkcode--btn" @click="refreshCheckCode"><img :src="checkcodeImg" alt=""></div>
              </div>
              <div class="form-item__error" v-show="error.checkcode.isShow">* {{error.checkcode.msg}}</div>
            </div>
          </div>
          <div class="button-wrap">
            <button class="login-btn" :class="{'disabled': disabled}" @click="loginMethod">{{$t("userOperate.loginText")}}</button>
          </div>
          <div class="forget-register">
            <span @click="goForgetPass">{{$t("userOperate.forgetText")}}</span>
            <span @click="goRegister">{{$t("userOperate.registerText")}}</span>
          </div>
        </div>
        <div class="bottom-footer">
          <p>{{$t("userOperate.loginTips")}}</p>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { validPassword, validEmail } from "@/utils/validate";
import { mapActions, mapMutations, mapGetters } from "vuex";
export default {
  name: "loginModule",
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      seen: false,
      random: Math.random()
        .toString(36)
        .substr(2),
      login: {
        email: "",
        password: "",
        checkcode: ""
      },
      error: {
        email: {
          msg: "",
          isShow: false
        },
        password: {
          msg: "",
          isShow: false
        },
        checkcode: {
          msg: "",
          isShow: false
        }
      }
    };
  },
  computed: {
    checkcodeImg() {
      return `//api.longtuthailand.com/tha/codeimg?nonce=${this.random}`;
    },
    logo() {
      return this.$i18n.locale === 'th' ? require('@/assets/images/logo-th.png') : require('@/assets/images/login-logo.png')
    },
    disabled() {
      return (
        !this.login.email ||
        !this.login.password ||
        !this.login.checkcode ||
        this.login.checkcode.length !== 4 ||
        !this.validateEmail() ||
        !this.validatePass()
      );
    },
    ...mapGetters(["redirect"])
  },
  methods: {
    loginMethod() {
      if (this.disabled) return;
      if (this._validate()) {
        const data = {
          username: this.login.email,
          password: this.login.password,
          vcode: this.login.checkcode,
          nonce: this.random
        };
        this.loginByEmail(data)
          .then(res => {
            this.$message({
              message: this.$t("userOperate.loginSuccess"), //登录成功
              type: "success"
            });
            this.flag = true;
            this.redirect
              ? this.$router.push({ path: this.redirect })
              : this.$router.push({ path: "/index" });
            //关闭弹窗
            this.closeLoginPop();
          })
          .catch(err => {
            this.refreshCheckCode();
          });
      }
    },
    inputFocus(inputTxt) {
      inputTxt.isShow = false;
    },
    //密码显示与隐藏
    toggleCanSee() {
      this.seen = !this.seen;
    },
    //刷新验证码
    refreshCheckCode() {
      this.random = Math.random()
        .toString(36)
        .substr(2);
    },
    // 成功之后清空信息
    clearMessage() {
      this.login.email = "";
      this.login.password = "";
      this.login.checkcode = "";
      this.error.email.isShow = false;
      this.error.password.isShow = false;
      this.error.checkcode.isShow = false;
    },
    //总的验证
    _validate() {
      if (
        this.validateEmail() &&
        this.validatePass() &&
        this.validateCheckcode()
      ) {
        return true;
      }
    },
    //验证邮箱
    validateEmail() {
      let login = this.login;
      let error = this.error;
      if (!login.email) {
        error.email.msg = this.$t("userOperate.emptyEmail");
        error.email.isShow = true;
        return false;
      } else if (!validEmail(login.email)) {
        error.email.msg = this.$t("userOperate.validEmail");
        error.email.isShow = true;
        return false;
      } else if (login.email.length > 40 || login.email.length < 6) {
        error.email.msg = this.$t("userOperate.validEmailLen");
        error.email.isShow = true;
        return false;
      } else {
        error.email.msg = "";
        error.email.isShow = false;
      }
      return true;
    },
    //验证密码
    validatePass() {
      let login = this.login;
      let error = this.error;
      if (!login.password) {
        error.password.msg = this.$t("userOperate.emptyPsw");
        error.password.isShow = true;
        return false;
      } else if (!validPassword(login.password)) {
        error.password.msg = this.$t("userOperate.validPsw");
        error.password.isShow = true;
        return false;
      } else {
        error.password.msg = "";
        error.password.isShow = false;
      }
      return true;
    },
    //验证验证码
    validateCheckcode() {
      let login = this.login;
      let error = this.error;
      if (!login.checkcode || login.checkcode.length != 4) {
        error.checkcode.msg = this.$t("userOperate.emptyCode");
        error.checkcode.isShow = true;
        return false;
      } else {
        error.checkcode.msg = "";
        error.checkcode.isShow = false;
      }
      return true;
    },
    //忘记密码
    goForgetPass() {
      this.closeLoginPop();
      this.$router.push({ path: "/forget" });
    },
    //注册
    goRegister() {
      this.closeLoginPop();
      this.$router.push({ path: "/register" });
    },
    //关闭弹窗
    closeLoginPop() {
      this.refreshCheckCode();
      this.clearMessage();
      this.setLoginPopState(false);
    },
    ...mapActions({
      loginByEmail: "loginByEmail"
    }),
    ...mapMutations({
      setLoginPopState: "SET_LOGIN_POP_STATE"
    })
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/variable.scss";
.login-wrapper {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 9;
  background-color: rgba(0, 0, 0, 0.5);
  .login-container {
    width: 486px;
    height: 500px;
    transform: translate(-50%, -50%);
    background: #fff;
    position: absolute;
    left: 50%;
    top: 50%;
    border-radius: 8px;
    overflow: hidden;
    .close-btn {
      width: 25px;
      height: 25px;
      background: url(~@/assets/images/close-btn.png);
      position: absolute;
      right: 12px;
      top: 12px;
      cursor: pointer;
    }
    .logo-wrap {
      width: 100%;
      padding: 25px 20px 18px 20px;
      box-sizing: border-box;
      text-align: center;
    }
  }
  .form-container {
    width: 100%;
    margin: 0 auto;
    padding: 0 77px;
    padding-top: 10px;
    box-sizing: border-box;
    .form-item {
      width: 100%;
      height: 38px;
      padding-bottom: 30px;
      .form-item__content {
        line-height: 38px;
        width: 330px;
        position: relative;
        .form-item__input {
          height: 38px;
          width: 100%;
          > input {
            width: 100%;
            height: 38px;
          }
          &.only--password {
            position: relative;
            > input {
              padding-right: 40px;
            }
            .cansee-icon {
              display: block;
              float: left;
              width: 40px;
              height: 36px;
              background: url(~@/assets/images/see-close.png) no-repeat center;
              position: absolute;
              right: 0;
              top: 0;
              cursor: pointer;
              &.cansee {
                background: url(~@/assets/images/see-open.png) no-repeat center;
              }
            }
          }
          &.only--checkcode {
            overflow: hidden;
            > input {
              width: 222px;
              float: left;
            }
            .checkcode--btn {
              width: 86px;
              height: 38px;
              box-sizing: border-box;
              float: right;
              text-align: center;
              > img {
                width: 100%;
                height: 100%;
              }
            }
          }
        }
      }
    }
    .button-wrap {
      width: 100%;
      margin-top: 20px;
      text-align: center;
      button {
        width: 100%;
        height: 42px;
        line-height: 42px;
        font-size: 18px;
        color: #fff;
        background: $blue;
        border-radius: 5px;
        &.disabled {
          background: $disabled;
          cursor: not-allowed;
          &:hover {
            opacity: 1;
          }
        }
      }
    }
    .forget-register {
      width: 100%;
      overflow: hidden;
      margin-top: 12px;
      > span {
        cursor: pointer;
        color: $blue;
        font-size: 16px;
        &:first-child {
          float: left;
        }
        &:last-child {
          float: right;
        }
      }
    }
  }
  .bottom-footer {
    width: 100%;
    height: 50px;
    background: #f6f6f6;
    text-align: center;
    line-height: 50px;
    color: $activeFont;
    border-top: 1px solid #ccc;
    position: absolute;
    bottom: 0;
    left: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Login.vue